import React, { useEffect } from 'react'
import logger from 'logger'
import { useUser } from 'modules/user'
import { useQueueResolvePostponedItems } from 'modules/queue'
import { useSubscription } from 'modules/subscription'
import { useOptInEmailResolvePostponedProjects } from 'modules/user/optIn'


type ResolvePostponedProps = {
  withNotification?: boolean
  withoutPremiumModal?: boolean
}

const ResolvePostponed: React.CFC<ResolvePostponedProps> = ({ children, withoutPremiumModal, withNotification }) => {
  const { isLoggedIn, isFetching: isUserFetching } = useUser()
  const { subscription, isFetching: isSubscriptionFetching } = useSubscription()

  const isFetching = isUserFetching || isSubscriptionFetching
  // ATTN we can't add LEP if user doesn't have an active subscription
  const isSubscriptionActive = subscription?.isActive ?? false

  const postponedItemsHandler = useQueueResolvePostponedItems()
  const postponedOptInEmailHandler = useOptInEmailResolvePostponedProjects()

  useEffect(() => {
    if (isFetching) {
      return
    }

    if (isLoggedIn) {
      postponedItemsHandler({
        withNotification,
        withUpgradeFlow: false,
        withErrorModals: false,
        withLEP: isSubscriptionActive,
        withPriorityProducts: isSubscriptionActive,
        withoutPremiumModal,
      }).catch((error) => {
        logger.warn(error)
      })

      // Send user email to postponed iterable projects
      postponedOptInEmailHandler()
    }
  }, [ postponedItemsHandler, postponedOptInEmailHandler, isFetching, isLoggedIn, isSubscriptionActive, withNotification, withoutPremiumModal ])

  return (
    <>
      {children}
    </>
  )
}


export default ResolvePostponed
